/**
 * Login Visibility constants
 */

export const SET_LOGIN_VISIBILITY = 'SET_LOGIN_VISIBILITY';
export default SET_LOGIN_VISIBILITY;
